var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6654 35.4167H34.9987V16.6333C34.9987 15.6 34.532 14.6333 33.7154 14L31.6654 12.4L31.632 8.31666C31.632 7.39999 30.882 6.66666 29.9654 6.66666H24.282L22.0487 4.93333C20.8487 3.98333 19.1487 3.98333 17.9487 4.93333L6.28203 14C5.46536 14.6333 4.9987 15.6 4.9987 16.6167L4.91536 35.4167H3.33203C2.6487 35.4167 2.08203 35.9833 2.08203 36.6667C2.08203 37.35 2.6487 37.9167 3.33203 37.9167H36.6654C37.3487 37.9167 37.9154 37.35 37.9154 36.6667C37.9154 35.9833 37.3487 35.4167 36.6654 35.4167ZM10.832 21.25V18.75C10.832 17.8333 11.582 17.0833 12.4987 17.0833H15.832C16.7487 17.0833 17.4987 17.8333 17.4987 18.75V21.25C17.4987 22.1667 16.7487 22.9167 15.832 22.9167H12.4987C11.582 22.9167 10.832 22.1667 10.832 21.25ZM24.1654 35.4167H15.832V30.8333C15.832 29.45 16.9487 28.3333 18.332 28.3333H21.6654C23.0487 28.3333 24.1654 29.45 24.1654 30.8333V35.4167ZM29.1654 21.25C29.1654 22.1667 28.4154 22.9167 27.4987 22.9167H24.1654C23.2487 22.9167 22.4987 22.1667 22.4987 21.25V18.75C22.4987 17.8333 23.2487 17.0833 24.1654 17.0833H27.4987C28.4154 17.0833 29.1654 17.8333 29.1654 18.75V21.25Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.abee530ab4c3122d6ffe5ab0eeea99b5.svg";
export { ForwardRef as ReactComponent };